var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text)?_c('div',{staticClass:"info-message",class:_vm.status},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"info-message__text",domProps:{"innerHTML":_vm._s(_vm.text)}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }